import * as types from '../types.js';
import { getSialApiHost } from '../api.js';

function esc(s)
{
	if (s == null || s === '')
		return '';
	const t = String(s);
	return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function _dirPt(d)
{
	if (d === 'inbound')
		return 'Entrada';
	if (d === 'outbound')
		return 'Saída';
	return d ? String(d) : '—';
}

/** Cabeçalho SESSP (TechHub/IBL) — ativado pela API quando INTEGRATION_CENTRAL_BANNER=sessp */
function _healthBannerSesspHtml(summary)
{
	const agg = summary.banner_aggregates != null ? summary.banner_aggregates : (summary.aggregates || []);
	const lines = agg.length
		? agg.map((a) => {
			const key = (a.integration_key || '').toLowerCase() === 'techhub_ibl' ? 'TechHub — IBL' : esc(a.integration_key || '—');
			const fails = a.fail_period ?? 0;
			const last = a.last_at != null ? esc(String(a.last_at)) : '—';
			const failTxt = fails === 0 ? 'nenhuma falha no período' : `${fails} falha(s) no período`;
			return `<div style="margin-top:0.2rem;">• <strong>${key}</strong> — ${_dirPt(a.direction)}: último evento <code style="font-size:0.85em;">${last}</code> · ${failTxt}</div>`;
		}).join('')
		: `<div style="margin-top:0.25rem;color:var(--color-muted,#444);">Nenhum evento da integração TechHub neste período.</div>`;
	const notes = (summary.notes || []).map((n) => `<div style="margin-top:0.25rem;">${esc(n)}</div>`).join('');
	return `
		<div class="integration-health-banner" style="margin:0.5rem 0 1rem;padding:0.75rem 1rem;border:1px solid var(--color-border,#ccc);border-radius:6px;background:var(--color-panel,#f9f9f9);font-size:0.9rem;">
			<div style="font-weight:bold;margin-bottom:0.35rem;">Integração SESSP — TechHub / IBL</div>
			<div style="color:var(--color-muted,#444);font-size:0.88rem;">Resumo das últimas <strong>${esc(String(summary.period_hours ?? 24))}</strong> horas (integração com o middleware da IBL).</div>
			${lines}
			<div style="margin-top:0.45rem;font-size:0.82rem;color:var(--color-muted,#555);">Em <strong>PRD</strong> o servidor deve rodar o cron <code>cron/tick</code> (pull + fila + status) — ver <code>doc/server/TECHHUB-IBL-CRON-SESSP-AWS.md</code>. Em <strong>QA</strong> use o menu: <strong>Buscar faturas na IBL</strong> (pull), depois <strong>Processar fila TechHub</strong> e, se precisar, <strong>Enviar status à IBL</strong>.</div>
			<div style="margin-top:0.5rem;font-size:0.82rem;color:var(--color-muted,#666);border-top:1px solid var(--color-border,#ddd);padding-top:0.45rem;">
				${notes}
			</div>
		</div>`;
}

function _healthBannerHtml(summary)
{
	if (!summary)
		return '';
	if (summary.banner_mode === 'sessp')
		return _healthBannerSesspHtml(summary);
	const p = summary.runner?.protheus;
	const st = p?.status || '—';
	const stClass = st === 'ok' ? 'integration-health-ok' : st === 'stale' ? 'integration-health-warn' : 'integration-health-bad';
	const rows = (summary.aggregates || []).map((a) =>
		`${a.integration_key} ${a.direction || '—'}: último ${a.last_at || '—'} (${a.fail_period ?? 0} falhas no período)`
	).join(' · ');
	return `
		<div class="integration-health-banner" style="margin:0.5rem 0 1rem;padding:0.75rem 1rem;border:1px solid var(--color-border,#ccc);border-radius:6px;background:var(--color-panel,#f9f9f9);font-size:0.9rem;">
			<div style="font-weight:bold;margin-bottom:0.35rem;">Saúde das integrações</div>
			<div><strong>Conector Protheus</strong> — <span class="${stClass}">${esc(st)}</span>${p?.last_heartbeat_at ? ` · último heartbeat: ${esc(String(p.last_heartbeat_at))}` : ''}</div>
			<div style="margin-top:0.25rem;"><strong>Espelho inbound (API)</strong> — ${summary.mirror_inbound_enabled ? 'ativo' : 'desligado (env)'}</div>
			<div style="margin-top:0.35rem;color:var(--color-muted,#444);">${esc(rows || 'Sem eventos no período.')}</div>
			<div style="margin-top:0.45rem;font-size:0.82rem;color:var(--color-muted,#666);">${esc((summary.notes || []).join(' '))}</div>
			${p?.hint ? `<div style="margin-top:0.35rem;font-size:0.82rem;">${esc(p.hint)}</div>` : ''}
		</div>
		<style>
			.integration-health-ok { color: #0a6e0a; font-weight: 600; }
			.integration-health-warn { color: #a65f00; font-weight: 600; }
			.integration-health-bad { color: #b00020; font-weight: 600; }
		</style>`;
}

export default async function(records)
{
	let banner = '';
	try
	{
		const base = getSialApiHost();
		const r = await fetch(`${base}/integration-events/summary?hours=24&stale_minutes=12`, { credentials: 'include' });
		if (r.ok)
			banner = _healthBannerHtml(await r.json());
	}
	catch (e) { /* evita quebrar a grade */ }

	return banner + `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: right; }
			.view td:nth-child(3)	{ text-align: center; }
			.view td:nth-child(4)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(5)	{ text-align: center; max-width: 5rem; }
			.view td:nth-child(6)	{ text-align: center; max-width: 5rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 24rem; }
			.view td:nth-child(8)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 16rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(12)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(13)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(14)	{ text-align: left; max-width: 8rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Evento</th>
					<th data-index="2" data-visible="${this.visible[1]}">Data/Hora</th>
					<th data-index="3" data-visible="${this.visible[2]}">Empresa</th>
					<th data-index="4" data-visible="${this.visible[3]}">Integração</th>
					<th data-index="5" data-visible="${this.visible[4]}">Direção</th>
					<th data-index="6" data-visible="${this.visible[5]}">Status</th>
					<th data-index="7" data-visible="${this.visible[6]}">Resumo</th>
					<th data-index="8" data-visible="${this.visible[7]}">Tipo</th>
					<th data-index="9" data-visible="${this.visible[8]}">ID entidade</th>
					<th data-index="10" data-visible="${this.visible[9]}">Erro</th>
					<th data-index="11" data-visible="${this.visible[10]}">Correlação</th>
					<th data-index="12" data-visible="${this.visible[11]}">Origem</th>
					<th data-index="13" data-visible="${this.visible[12]}">Registrado por</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record =>
				`<tr data-id='${record.id}'>
					<td><input type="checkbox"${this.isChecked(record.id)}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${this.format(types.datetime(), record.date_time)}</td>
					<td data-visible='${this.visible[2]}'>${await this.key('companies', record.company_id) || ''}</td>
					<td data-visible='${this.visible[3]}'>${esc(record.integration_key)}</td>
					<td data-visible='${this.visible[4]}'>${esc(record.direction)}</td>
					<td data-visible='${this.visible[5]}'>${esc(record.status)}</td>
					<td data-visible='${this.visible[6]}'>${esc(record.summary)}</td>
					<td data-visible='${this.visible[7]}'>${esc(record.entity_type)}</td>
					<td data-visible='${this.visible[8]}'>${esc(record.entity_id)}</td>
					<td data-visible='${this.visible[9]}'>${esc(record.error_message)}</td>
					<td data-visible='${this.visible[10]}'>${esc(record.correlation_id)}</td>
					<td data-visible='${this.visible[11]}'>${esc(record.source)}</td>
					<td data-visible='${this.visible[12]}'>${await this.key('users', record.recorded_by) || ''}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};
